import { combineReducers } from "redux"
import auth from "./auth"
import users from "./user"
var allReducer = combineReducers({
    auth,
    users
})

export default allReducer;